/* esm.sh - mdast-util-gfm-strikethrough@2.0.0 */
export * from "/*mdast-util-gfm-strikethrough@2.0.0/esnext/mdast-util-gfm-strikethrough.mjs";
